export const checkboxTheme = { defaultProps: { size: 'lg' } }
